export interface IManufacturer {
  id: number;
  name: string;
  description: string;
  imageUrl: string;
  isActive: boolean;
}

export class Manufacturer implements IManufacturer {
  id: number;
  name: string;
  description: string;
  imageUrl: string;
  isActive: boolean;

  constructor(init: ManufacturerFormValues) {
    Object.assign(this, init);
    this.isActive = true;
  }
}

export class ManufacturerFormValues {
  id?: number;
  name: string = "";
  description: string = "";
  imageUrl: string = "";

  constructor(manufacturer?: ManufacturerFormValues) {
    if (manufacturer) {
      this.id = manufacturer.id;
      this.name = manufacturer.name;
      this.description = manufacturer.description;
      this.imageUrl = manufacturer.imageUrl ?? "";
    }
  }
}
